import React from "react";
import { CookiesProvider } from "react-cookie";
import { ToastContainer } from "react-toastify";

import { ApolloProvider } from "@apollo/client";
import { IntelligemsThemeProvider } from "@intelligems/ig-theme";
import { StyledEngineProvider } from "@mui/material";
import { Theme } from "@mui/material/styles";
import * as Sentry from "@sentry/react";
import { useLoadScripts } from "@src/hooks/loadScripts";
import { queryClient } from "@src/queryClient";
import { theme } from "@src/theme";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import "@mui/styles";

import { AppProvider } from "./providers/AppProvider";
import { shopifyGqlClient } from "./providers/gqlProvider";
import { AppRoutes } from "./routes";

import "react-toastify/dist/ReactToastify.css";
import "./App.css";

declare module "@mui/styles/defaultTheme" {
  interface DefaultTheme extends Theme {}
}

const Component = () => {
  useLoadScripts();
  return (
    <QueryClientProvider client={queryClient}>
      <ApolloProvider client={shopifyGqlClient}>
        <StyledEngineProvider injectFirst>
          <IntelligemsThemeProvider theme={theme}>
            {/* @ts-ignore */}
            <CookiesProvider>
              <ReactQueryDevtools initialIsOpen={false} />
              <AppProvider>
                <ToastContainer closeOnClick={true} autoClose={5000} />
                <AppRoutes />
              </AppProvider>
            </CookiesProvider>
          </IntelligemsThemeProvider>
        </StyledEngineProvider>
      </ApolloProvider>
    </QueryClientProvider>
  );
};

export const App = Sentry.withProfiler(Component);
